import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetChangeLog as GetChangelogQuery,
    GetChangeLogVariables as GetChangelogQueryVariables,
    ChangelogEventFragment,
} from 'nutshell-graphql-types';

import GET_CHANGELOG from './graphql/queries/get-changelog.graphql';

export const useGetChangelog = (entityId: string) => {
    const {
        data,
        loading: isLoading,
        error,
    } = useQuery<GetChangelogQuery, GetChangelogQueryVariables>(GET_CHANGELOG, {
        variables: {entityId},
        fetchPolicy: 'cache-and-network',
    });

    const changelog = data ? data.changelog : null;
    const entries: ChangelogEventFragment[] = changelog
        ? changelog.edges.map((edge) => edge.node)
        : [];
    const totalCount = (changelog && changelog.totalCount) || 0;

    return {
        entries,
        totalCount,
        isLoading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
